import { Pipe, PipeTransform } from '@angular/core';
import { getStringFromArray } from '../array/array.helper';

@Pipe({
  name: 'appList',
  standalone: true,
})
export class ListPipe implements PipeTransform {
  public transform(list: (string | number)[] | undefined | null, noValueString: string = '-'): string {
    return list?.length ? getStringFromArray(list) : noValueString;
  }
}
